var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "permission-item" },
    [
      _c("permission-info", {
        attrs: { icon: _vm.icon, text: _vm.description },
      }),
      _vm._v(" "),
      _c("permission-toggle", {
        attrs: { "is-active": _vm.isSelected, "is-disabled": _vm.isDisabled },
        on: { toggle: _vm.togglePermission },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }